<ion-row>
  <ion-col size="12" size-md="10" offset-md="1" size-lg="8" offset-lg="2">
    @if (_showAnleggsliste === true) {
    <div class="anleggs-liste-forbruk">
      <ion-select
        [(ngModel)]="valgtAnlegg"
        (ngModelChange)="emitAnlegg(valgtAnlegg)"
        interface="popover"
        justify="space-between"
        labelPlacement="stacked"
        [interfaceOptions]="{
            header: 'Velg anlegg',
          }"
        #adrSelect
        class="w-full md:max-w-full"
      >
        @for (adr of anleggList; track $index) {
        <ion-select-option [value]="adr">
          @if (anleggIsInactive(adr, mineAvtaler)) {
          <span>[Avsluttet]</span>
          }
          {{ adr?.adresse }} {{ showMpid(adr) }}
          @if (adr.beskrivelse) {
          <span>({{ adr.beskrivelse }})</span>
          } &nbsp;<ion-icon
            class="adresse"
            name="caret-down-outline"
          ></ion-icon>
        </ion-select-option>
        }
      </ion-select>
    </div>
    } @if (_showAnleggsliste === false) {
    <div class="anleggs-adresse-forbruk">
      <p class="m-0">
        {{ valgtAnlegg?.adresse }}
      </p>
    </div>
    }
  </ion-col>
</ion-row>
